import React from 'react';
import './IMATMeditaliaPlus.css'; // Make sure to create and link this CSS file
import { useNavigate } from 'react-router-dom';
import backgroundImage from '../../assets/bg3.avif'; // Adjust the path to your image



const IMATMeditaliaPlus = () => {
    const navigate = useNavigate();

    const handleEnrollClick = () => {
        navigate('/imat-course'); // Use navigate instead of window.location.href
    };

    return (
        <div className="course-detail-container"
        style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
        }}>
            <div className="course-description">
                <h5>IMAT Meditalia+ Plus Course
                (€310) – 3 Months</h5>
                <p>Live Lectures (108 hours) [3 months] Starting March 2025</p>
                <ul>
                    <li>Access to simulation. (12)</li>
                    <li>Updated IMAT Material</li>
                    <li>Full guidance with personal interaction to improve scores</li>
                    <li>Bi-weekly mock tests with ranking</li>
                    <li>Access to online materials and career counseling</li>
                </ul>
                <button className="buy-button" onClick={handleEnrollClick}>Enroll Now</button>
            </div>

            {/* Right Section - Course Description */}
            <div className="course-description">
                <h2>About the Course</h2>
                <p>
                This comprehensive 3-month course provides structured learning, expert guidance, and
high-quality study materials to help students excel in the IMAT exam.
What’s Included?
                </p>
                <h3>What’s Included?</h3>
                <ul>
                    <li>
                        <strong>Live Lectures (108 Hours)</strong> –Interactive classes covering all IMAT subjects, ensuring a
                        strong conceptual foundation.
                    </li>
                    <li>
                        <strong>12 MedItalia Simulations</strong> – Exclusive IMAT-style exams by Future MedsAcademy to
                        enhance problem-solving skills and test readiness.
                    </li>
                    <li>
                        <strong>Updated IMAT Study Material</strong> – Access to the latest resources, including notes, past
                        papers, and exam strategies.
                    </li>
                    <li>
                        <strong>Bi-Weekly Mock Tests with Ranking</strong> – Regular assessments to track performance and
                        improve accuracy.
                    </li>
                    <li>
                        <strong>Personalized Guidance & Career Counseling</strong> – One-on-one mentoring for IMAT
                        preparation, university selection, and application support.
                    </li>
                    <li>
                        <strong>Perfect for students who want a structured, interactive, and guided approach to
                        mastering the IMAT!</strong>
                    </li>
                </ul>
                <p>
                Perfect for students who want a structured, interactive, and guided approach to
                mastering the IMAT!
                </p>
            </div>
        </div>
    );
};

export default IMATMeditaliaPlus;
